import Filters from '@/utils/input/filters';
import { registerModuleFilters } from '@/utils/input/filters';

export const CreatedDateFilter = {
  ...Filters.DateFilter,
  name: 'dateRange',
  label: 'global.text.createdDate',
};

export const UpdatedDateFilter = {
  ...Filters.DateFilter,
  name: 'updatedDateRange',
  label: 'global.text.updatedDate',
};

export const groupsFiltersConfig = [Filters.IsActiveFilter, CreatedDateFilter, UpdatedDateFilter];

registerModuleFilters('dynamicEntityGroups', groupsFiltersConfig);

export default groupsFiltersConfig;
